import { ChemistriesPage } from "./ChemistriesPage";

const Chemistries = () => {
	return <ChemistriesPage />;
};
export default Chemistries;
